import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { SelectLookupControl } from "@/Common/Components/Inputs/SelectLookupControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LifeStageModeEnum } from "@/Patient/Models/LifeStageModeEnum";

import styles from "./LifeStageAgeMode.module.scss";

interface ILifeStageAgeModeProps {
    lifeStageAgeSelectedAgeAtOnsetUnit: string;
    lifeStageAvailableAgeAtOnsetUnits: FlatLookupView[];
    lifeStageAgeAtOnset: number;
    useThreeCols: boolean;
    onLifeStageAgeChange: (value: string) => void;
    onLifeStageModeClick: (newMode: LifeStageModeEnum) => void;
    onLifeStageAgeUnitChange: (value: string) => void;
}

function LifeStageAgeMode(props: ILifeStageAgeModeProps): JSX.Element {
    const { getText } = useTranslation();
    const renderLifeStageModeButtons = (): JSX.Element => (
        <>
            <a className="pointer" onClick={() => props.onLifeStageModeClick(LifeStageModeEnum.Date)}>
                <span>
                    {getText("StartDateLabel")}
                </span>
            </a>
            {" | "}
            <a className="pointer" onClick={() => props.onLifeStageModeClick(LifeStageModeEnum.LifeStage)}>
                <span>
                    {getText("LifeStageDLabel")}
                </span>
            </a>
        </>
    );

    return (
        <tr key="age">
            <td className="c1">
                <span>{getText("AgeAtOnsetLabel")}</span>
            </td>
            <td className="c2">
                <div>
                    <span>
                        <input
                            data-cy="medicalItems-medicalReaction-ageAtOnset-value"
                            type="number"
                            className={`form-control ${styles.ageOnSetInput}`}
                            min="0"
                            onChange={e => props.onLifeStageAgeChange(e.target.value)}
                            value={(props.lifeStageAgeAtOnset != null) ? props.lifeStageAgeAtOnset.toString() : ""}
                        />
                    </span>
                    <span className="padding-sm-left">
                        <SelectLookupControl
                            dataCy="medicalItems-medicalReaction-ageAtOnset-type"
                            IncludeEmptyChoice={false}
                            className={styles.ageOnSetSelectBox}
                            Value={props.lifeStageAgeSelectedAgeAtOnsetUnit}
                            AvailableValues={props.lifeStageAvailableAgeAtOnsetUnits?.map(unit => unit.ToComboboxItem()) ?? []}
                            Callback={value => props.onLifeStageAgeUnitChange(value)}
                        />
                    </span>
                </div>
            </td>
            {props.useThreeCols && (
                <td className="c3" colSpan={2}>
                    {renderLifeStageModeButtons()}
                </td>
            )}
            {!props.useThreeCols && (
                <>
                    <td className="c3" />
                    <td className="c4" data-cy="medicalItems-medicalReaction-lifeStage-modes">
                        {renderLifeStageModeButtons()}
                    </td>
                </>
            )}
        </tr>
    );
}

export { LifeStageAgeMode };
